module.exports = __webpack_public_path__ + "img/kony.4a36827b.jpg";